import React, { useEffect, useState } from "react";
import { Stack } from "@fluentui/react";
import { useId, Input, Label, InputProps } from "@fluentui/react-components";

// export const Inputs = (props: any) => {
//   var isDisabled = props.disabled != undefined ? props.disabled : false;
//   const smallId = useId("input-small");
//   const [value, setValue] = useState('');
  
//   const handleInput = (data: any) => {
//     setValue(data.target.value);
//   };

//   useEffect(() => {
//     props.inputChange({...props?.inputVal, name: value});
//   }, [value]);

//   useEffect(() => {
//     console.log("props?.inputVal?.name=",props?.inputVal?.name);
    
//     setValue(props?.inputVal?.name);
//   }, [props?.inputVal]);

//   return (
//     <Stack>
//       <Label size="small" htmlFor={smallId}></Label>
//       <Input 
//         size="small" 
//         // value={value?.length > 0 ? value : props?.inputVal?.name} 
//         value={value} 
//         id={smallId} 
//         maxLength={50} 
//         disabled={isDisabled} 
//         onChange={handleInput} 
//         //onBlur={(e) => props.inputChange({...props?.inputVal, name: value})} 
//         required={props?.required} 
//       />
//     </Stack>
//   );
// };

export const Inputs = (props: any) => {
  var isDisabled = props.disabled != undefined ? props.disabled : false;
  const smallId = useId("input-small");
  const [value, setValue] = useState('');
  
  const handleInput = (data: any) => {
    setValue(data.target.value);
  };

  useEffect(() => {
    props.inputChange({...props?.inputVal, name: value});
  }, [value]);

  return (
    <Stack>
      <Label size="small" htmlFor={smallId}>
      </Label>
      <Input 
        size="small" 
        value={value?.length > 0 ? value : props?.inputVal?.name} 
        id={smallId} 
        maxLength={150} 
        disabled={isDisabled} 
        onChange={handleInput} 
        required={props?.required} 
      />
    </Stack>
  );
};
